import React from 'react';
import { Document, Page, View, Text, Image, StyleSheet, Font } from '@react-pdf/renderer';
import moment from 'moment/moment';
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';
import SFRegular from '../../assets/font/SF-Pro-Display-Regular.ttf';
import SFMedium from '../../assets/font/SF-Pro-Display-Medium.ttf';
import SFSemibold from '../../assets/font/SF-Pro-Display-Bold.ttf';
import NSLight from '../../assets/font/NotoSansSC-Light.ttf';
import NSRegular from '../../assets/font/NotoSansSC-Regular.ttf';
import NSMedium from '../../assets/font/NotoSansSC-Medium.ttf';
import NSSemibold from '../../assets/font/NotoSansSC-SemiBold.ttf';
import NSBold from '../../assets/font/NotoSansSC-Bold.ttf';

// Register fonts
Font.register({
  family: 'SF-Regular',
  src: SFRegular,
});
Font.register({
  family: 'SF-Medium',
  src: SFMedium,
});
Font.register({
  family: 'SF-Semibold',
  src: SFSemibold,
});
Font.register({
  family: 'NS-Light',
  src: NSLight,
});
Font.register({
  family: 'NS-Regular',
  src: NSRegular,
});
Font.register({
  family: 'NS-Medium',
  src: NSMedium,
});
Font.register({
  family: 'NS-Semibold',
  src: NSSemibold,
});
Font.register({
  family: 'NS-Bold',
  src: NSBold,
});

const isEmptyString = (value) => value != null && String(value).trim().length !== 0;

const Classic_template_2_PDF = ({
  document_number,
  business_detail,
  document_issue_date,
  document_due_date,
  client_detail,
  items,
  discount,
  discount_type,
  tax_amount,
  tax_label,
  document_note,
  template,
  document_currency,
  document_type,
  localization,
  signature_name,
  signature
}) => {
  const business_detaill = JSON.parse(business_detail) || {};
  const itemss = JSON.parse(items) || [];
  const client_detaill = JSON.parse(client_detail) || {};
  const document_currencyy = JSON.parse(document_currency) || {};
  const templatee = JSON.parse(template) || {};
  const localizationn =
    localization === 'zh' ? zh :
    localization === 'de' ? de :
    localization === 'en' ? en :
    localization === 'es' ? es :
    localization === 'fr' ? fr :
    localization === 'it' ? it :
    localization === 'pt' ? pt : en;

  const styles = StyleSheet.create({
    page: { backgroundColor: templatee?.selectedcolor?.primary, padding: 20 },
    header: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 20 },
    businessInfo: { flex: 1 },
    businessName: { fontSize: 24, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.textcolor, marginBottom: 5 },
    businessText: { fontSize: 10, marginVertical:1, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor2 },
    logo: { width: 130, height: 130 },
    sectionTitle: { fontSize: 14, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.textcolor, marginTop: 20, marginBottom: 5 },
    clientRow: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 10 },
    clientColumn: { flex: 1 },
    metaRow: { marginVertical:1 ,flexDirection: 'row', justifyContent: 'space-between' },
    metaLabel: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor2 },
    metaValue: { fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor },
    tableHeader: { borderTopWidth:1, borderLeftWidth:1, borderRightWidth:1 ,flexDirection: 'row', backgroundColor: templatee?.selectedcolor?.secondary, borderColor:templatee?.selectedcolor?.bordercolor, padding: 5 },
    tableHeaderText: { flex: 1, fontSize: 10, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', color: templatee?.selectedcolor?.tableheadercolor },
    tableRow: { flexDirection: 'row', padding: 5, borderBottomWidth: 1, borderLeftWidth:1, borderRightWidth:1, borderColor: templatee?.selectedcolor?.bordercolor },
    tableCell: { flex: 1, fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor },
    tableCellCenter: { flex: 1, fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor, textAlign: 'center' },
    tableCellRight: { flex: 1, fontSize: 10, fontFamily: localization=="zh"?'NS-Regular':'SF-Regular', color: templatee?.selectedcolor?.textcolor, textAlign: 'right' },
    totalsRow: { flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 1, padding: 5, borderColor: templatee?.selectedcolor?.bordercolor },
    totalsLabel: { fontSize: 10, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', color: templatee?.selectedcolor?.textcolor },
    totalsValue: { fontSize: 10, fontFamily: localization=="zh"?'NS-Medium':'SF-Medium', color: templatee?.selectedcolor?.textcolor, textAlign: 'right' },
    signature: { marginTop: 10, transform: 'scale(0.8)' },
    signatureName: { fontSize: 9, fontFamily: localization=="zh"?'NS-Semibold':'SF-Semibold', color: templatee?.selectedcolor?.textcolor, textAlign: 'center' }
  });

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.businessInfo}>
            <Text style={styles.businessName}>{business_detaill?.business_name}</Text>
            {(isEmptyString(business_detaill?.business_phone_1)||isEmptyString(business_detaill?.business_phone_2)) &&(<Text style={styles.businessText}>{business_detaill?.business_phone_1}{isEmptyString(business_detaill?.business_phone_2)&&" - "+business_detaill?.business_phone_1}</Text>)}
            {isEmptyString(business_detaill?.business_fax) && <Text style={styles.businessText}>{localizationn?.fax}: {business_detaill?.business_fax}</Text>}
            {isEmptyString(business_detaill?.business_street_1) && <Text style={styles.businessText}>{business_detaill?.business_street_1}</Text>}
            {isEmptyString(business_detaill?.business_street_2) && <Text style={styles.businessText}>{business_detaill?.business_street_2}</Text>}
            {isEmptyString(business_detaill?.business_city) && <Text style={styles.businessText}>{business_detaill?.business_city}</Text>}
            {isEmptyString(business_detaill?.business_country) && <Text style={styles.businessText}>{business_detaill?.business_country}</Text>}
            {isEmptyString(business_detaill?.business_email) && <Text style={styles.businessText}>{business_detaill?.business_email}</Text>}
            {isEmptyString(business_detaill?.business_website) && <Text style={styles.businessText}>{business_detaill?.business_website}</Text>}
          </View>
          {business_detaill?.business_logo && <Image src={{
              uri: business_detaill.business_logo,
              method: 'GET',
              headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0',
              },
              body: null
            }}  style={styles.logo} />}
        </View>
        {/* Client Info */}
        <Text style={styles.sectionTitle}>{document_type === 'estimate' ? localizationn?.estimate_to : localizationn?.invoice_to}</Text>
        <View style={styles.clientRow}>
          <View style={styles.clientColumn}>
            {isEmptyString(client_detaill?.client_name) && <Text style={[styles.businessText,{fontSize:11, fontFamily:localization=="zh"?'NS-Medium':'SF-Medium'}]}>{client_detaill?.client_name}</Text>}
            {isEmptyString(client_detaill?.client_phone) && <Text style={styles.businessText}>{client_detaill?.client_phone}</Text>}
            {isEmptyString(client_detaill?.client_mobile) && <Text style={styles.businessText}>{client_detaill?.client_mobile}</Text>}
            {isEmptyString(client_detaill?.client_fax) && <Text style={styles.businessText}>{localizationn?.fax}: {client_detaill?.client_fax}</Text>}
            {isEmptyString(client_detaill?.client_email) && <Text style={styles.businessText}>{client_detaill?.client_email}</Text>}
          </View>
          <View style={styles.clientColumn}>
            {isEmptyString(client_detaill?.client_address_1) && <Text style={styles.businessText}>{client_detaill?.client_address_1}</Text>}
            {isEmptyString(client_detaill?.client_address_2) && <Text style={styles.businessText}>{client_detaill?.client_address_2}</Text>}
            {isEmptyString(client_detaill?.client_city) && <Text style={styles.businessText}>{client_detaill?.client_city} {client_detaill?.client_zip}</Text>}
            {isEmptyString(client_detaill?.client_state) && <Text style={styles.businessText}>{client_detaill?.client_state}</Text>}
            {isEmptyString(client_detaill?.client_country) && <Text style={styles.businessText}>{client_detaill?.client_country}</Text>}
          </View>
          <View style={styles.clientColumn}>
            <View style={styles.metaRow}>
              <Text style={styles.metaLabel}>{document_type === 'estimate' ? localizationn?.estimate_no : localizationn?.invoice_no}</Text>
              <Text style={styles.metaValue}>{document_number}</Text>
            </View>
            <View style={styles.metaRow}>
              <Text style={styles.metaLabel}>{localizationn?.issue_date}</Text>
              <Text style={styles.metaValue}>{moment(document_issue_date).format('MMM,DD,YYYY')}</Text>
            </View>
            <View style={styles.metaRow}>
              <Text style={styles.metaLabel}>{document_type === 'estimate' ? localizationn?.valid_until : localizationn?.due_date}</Text>
              <Text style={styles.metaValue}>
                {moment(document_due_date).isValid() ? moment(document_due_date).format("MMM,DD,YYYY") : 
                    document_due_date=="On Receipt"?localizationn?.on_receipt:
                    document_due_date=="3 days"?localizationn?.three_days:
                    document_due_date=="10 days"?localizationn?.ten_days:
                    document_due_date=="30 days"?localizationn?.thirty_days:
                    document_due_date=="No Valid Date"?localizationn?.no_valid_date:
                    document_due_date=="No Duo Date"?localizationn?.no_duo_date:
                    document_due_date
                }
              </Text>
            </View>
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={[styles.tableHeaderText,{textAlign:'left'}]}>{localizationn?.description}</Text>
          <Text style={[styles.tableHeaderText,{textAlign:'center'}]}>{localizationn?.quantity_up}</Text>
          <Text style={[styles.tableHeaderText,{textAlign:'center'}]}>{localizationn?.unit_price}</Text>
          <Text style={[styles.tableHeaderText,{textAlign:'right'}]}>{localizationn?.total}</Text>
        </View>

        {/* Table Rows */}
        {itemss.map((item, index) => (
          <View key={index} style={styles.tableRow}>
            <Text style={styles.tableCell}>{item.item_name}</Text>
            <Text style={styles.tableCellCenter}>{numberbeautify(item.item_quantity)}{item.item_type === 'service' ? `/${item.item_unit_type}` : ''}</Text>
            <Text style={styles.tableCellCenter}>{document_currencyy?.symbol}{numberbeautify(item.item_price)}</Text>
            <Text style={styles.tableCellRight}>{document_currencyy?.symbol}{numberbeautify(money_rounding(Number(item.item_price) * Number(item.item_quantity)))}</Text>
          </View>
        ))}

        {/* Totals */}
        <View style={{ marginTop: 10, flexDirection:'row', justifyContent:'space-between' }}>
          <View style={{ width:'50%'}}>
            {isEmptyString(document_note) && (
              <Text>{document_note}</Text>
            )}
          </View>
          <View style={{ width:'50%'}}>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{localizationn?.sub_total}</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}{
                numberbeautify(
                  money_rounding(
                    itemss?.reduce((total, item) => total + (Number(item.item_price) * Number(item.item_quantity)), 0)
                  )
                )
              }</Text>
            </View>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{localizationn?.discount}: {discount} {discount_type == 'percent' ? '%' : document_currencyy?.symbol}</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}
                {discount_type=='percent'?
                  numberbeautify(money_rounding(itemss?.reduce((total, item) => Number(total) + ((Number(item.item_price) * Number(item.item_quantity) * (Number(discount) / 100))),0))):
                  numberbeautify(money_rounding(discount))
                }</Text>
            </View>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{tax_label}: {tax_amount}%</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}
                                            {(() => {
                                              const items = itemss || [];
                                              const discountType = discount_type;
                                              const discountValue = Number(discount) || 0;
                                              // Calculate total of all items
                                              const totalAmount = items.reduce(
                                                (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                                0
                                              );
                                              // Calculate discount
                                              const discountAmount = discountType === 'percent'
                                                ? (totalAmount * discountValue / 100)
                                                : discountValue;
                                              // Calculate the total after discount
                                              const totalAfterDiscount = totalAmount - discountAmount;
                                              // Calculate the proportion of discount for each item
                                              const discountRatio = totalAmount > 0 ? discountAmount / totalAmount : 0;
                                              // Calculate tax only on taxable items after proportional discount
                                              const taxableAmount = items.reduce(
                                                (total, item) => {
                                                  if (item.item_tax_state) {
                                                    const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                                    const itemDiscount = itemTotal * discountRatio;
                                                    return total + (itemTotal - itemDiscount);
                                                  }
                                                  return total;
                                                },
                                                0
                                              );
                                              const taxTotal = taxableAmount * (Number(tax_amount) / 100);
                                              return numberbeautify(money_rounding(taxTotal));
                                            })()}</Text>
            </View>
            <View style={styles.totalsRow}>
              <Text style={styles.totalsLabel}>{localizationn?.total}</Text>
              <Text style={styles.totalsValue}>{document_currencyy?.symbol}
                                            {(() => {
                                              const items = itemss || [];
                                              const discountType = discount_type;
                                              const discountValue = Number(discount) || 0;
                                              // Calculate subtotal
                                              const subtotal = items.reduce(
                                                (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                                0
                                              );
                                              // Apply discount to subtotal
                                              const discountt = discountType === 'percent'
                                                ? (subtotal * discountValue / 100)
                                                : discountValue;
                                              const subtotalAfterDiscount = subtotal - discountt;
                                              // Calculate how much of the discounted subtotal is taxable
                                              const taxableRatio = subtotal > 0 ? subtotalAfterDiscount / subtotal : 0;
                                              // Calculate tax only on taxable items after proportional discount
                                              const taxTotal = items.reduce(
                                                (total, item) => {
                                                  if (item.item_tax_state) {
                                                    const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                                    const itemAfterDiscount = itemTotal * taxableRatio;
                                                    return total + (itemAfterDiscount * (Number(tax_amount) / 100));
                                                  }
                                                  return total;
                                                },
                                                0
                                              );
                                              const totalAfterDiscount = subtotalAfterDiscount + taxTotal;
                                              return numberbeautify(money_rounding(totalAfterDiscount));
                                            })()}</Text>
            </View>
          </View>
        </View>

        {/* Signature */}
        {signature && (
          <View style={{ width:'100%',flexDirection:'row', marginTop: 10 }}>
            <View style={{width:'50%',height:'100%'}} />
            <View style={{width:'50%',alignItems:'center'}}>
              <Image src={{
                  uri: signature,
                  method: 'GET',
                  headers: {
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Pragma': 'no-cache',
                    'Expires': '0',
                  },
                  body: null
                }} style={styles.signature} />
              <Text style={styles.signatureName}>{signature_name}</Text>
            </View>
          </View>
        )}
      </Page>
    </Document>
  );
};

export default Classic_template_2_PDF;
